import { ArrowUpCircleIcon, SparklesIcon, WrenchIcon } from 'lucide-react'
import type { ReleaseChangeType, ReleaseModule } from '../data/releaseNotes'

export const TYPE_STYLES: Record<
  ReleaseChangeType,
  { fr: string; en: string; className: string; Icon: typeof SparklesIcon }
> = {
  new: { fr: 'Nouveau', en: 'New', className: 'bg-indigo-50 text-[#4F46E5]', Icon: SparklesIcon },
  improved: { fr: 'Amélioré', en: 'Improved', className: 'bg-emerald-50 text-emerald-700', Icon: ArrowUpCircleIcon },
  fixed: { fr: 'Corrigé', en: 'Fixed', className: 'bg-amber-50 text-amber-700', Icon: WrenchIcon },
}

export const MODULE_LABELS: Record<ReleaseModule, { fr: string; en: string }> = {
  requetes: { fr: 'Requêtes', en: 'Requests' },
  communications: { fr: 'Communications', en: 'Communications' },
  id: { fr: 'ID', en: 'ID' },
  permis: { fr: 'Permis', en: 'Permits' },
  loisirs: { fr: 'Loisirs', en: 'Recreation' },
  plateforme: { fr: 'Plateforme', en: 'Platform' },
}
